import React from "react"
import { InteriorForm } from './Forms'
import CaseResultsSlider from '../components/CaseResultsSlider'
import SidebarMenu from '../components/SidebarMenu'

const Sidebar = () =>{

    return(
<div>
<InteriorForm />
<CaseResultsSlider />
<SidebarMenu />
</div>
    )
}
export default Sidebar